import { Component, Input, OnInit } from '@angular/core';
import { isDefined, NotificationIdentifier } from '@evorait/pace-core';
import {
    BaseFormsListComponent,
    FormsConstants,
    FormsState,
    getListForNotificationFactory,
    loadAllFormXml,
} from '@evorait/pace-forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-forms-list-wrapper',
    templateUrl: './forms-list-wrapper.component.html',
    styleUrls: ['./forms-list-wrapper.component.scss'],
    standalone: false,
})
export class FormsListWrapperComponent extends BaseFormsListComponent implements OnInit {
    @Input()
    public notificationIdentifier: NotificationIdentifier;

    @Input()
    public useFormListCache: boolean;

    public disableDownloadAll$: Observable<boolean>;

    protected readonly faEllipsisV = faEllipsisV;
    public constructor(private readonly store: Store<FormsState>) {
        super();
    }

    public ngOnInit(): void {
        this.disableDownloadAll$ = this.store
            .select(getListForNotificationFactory({ notification: this.notificationIdentifier }))
            .pipe(
                filter(isDefined),
                map((formList) =>
                    formList.entries.map((entry) => entry.cached).reduce((accu, cached) => accu && cached, true),
                ),
            );
    }

    public downloadAllForms(preview = false): void {
        this.store.dispatch(
            loadAllFormXml({
                status: preview ? FormsConstants.FORMSTATUS.PREVIEW : FormsConstants.FORMSTATUS.LOCK,
                notification: this.notificationIdentifier,
            }),
        );
    }
}
